var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusPaperplane = function SvgPlusPaperplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    viewBox: "0 0 184 184"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#007533;fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:4px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m92 155-16.49 23.97c-2.44 4.34-8.83 3.92-10.68-.71l-17.06-42.65M164 21.19 47.77 135.34 6.18 118.7c-5.12-2.05-5.66-9.09-.9-11.89L178 2",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176.11 3.4 84.16 138.45c-2.86 4.13-1.22 9.86 3.41 11.84l57.91 24.82c4.49 1.92 9.57-.99 10.18-5.84L181.97 5.64c.42-3.35-3.94-5.01-5.86-2.24Z",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4,
      stroke: "#00db33"
    }
  })));
};
export default SvgPlusPaperplane;